import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["list", "map", "btnmap", "btnlist"];

  connect() {
    if (window.innerWidth >= 1280) {
      this.showBothViews();
    } else {
      this.showList();
    }
  }

  showMap() {
    this.listTarget.classList.add("hidden");
    this.mapTarget.classList.remove("hidden");
    this.btnmapTarget.classList.add("hidden");
    this.btnlistTarget.classList.remove("hidden");
    window.dispatchEvent(new Event('resize'));
  }

  showList() {
    this.mapTarget.classList.add("hidden");
    this.listTarget.classList.remove("hidden");
    this.btnlistTarget.classList.add("hidden");
    this.btnmapTarget.classList.remove("hidden");
  }

  showBothViews() {
    this.listTarget.classList.remove("hidden");
    this.mapTarget.classList.remove("hidden");
    this.btnmapTarget.classList.add("hidden");
    this.btnlistTarget.classList.add("hidden");
    window.dispatchEvent(new Event('resize'));
  }
}


